import {CA} from './analytics/Analytics'
import {PatchNoteData} from './patch_notes/PatchNoteData'
import {ViewPopupPatchNotes} from './ui_popup/ViewPopupPatchNotes'
import {UIEntryUrlParameterController} from './UIEntryUrlParameterController'
import {FORCE_PORTRAIT_INACTIVITY_THRESHOLD_VERSION_DURATION} from '@colonist/types'

export class UIVersionController {
    static patchNoteRemoveAction: () => void = () => undefined
    static shouldForcePortraitModeIfLastVersionTooLongAgo: boolean = false

    private readonly thisVersion: number
    private readonly getStorageVersion: () => number | null
    private readonly updateStorageVersion: (no: number) => void
    willShowPatchnoteThisSession: boolean

    constructor(getStorageVersion: () => number | null, thisVersion: number, updateStorageVersion: (no: number) => void) {
        this.getStorageVersion = getStorageVersion
        this.thisVersion = thisVersion
        this.updateStorageVersion = updateStorageVersion
        this.willShowPatchnoteThisSession = false
        this.setShouldForcePortraitModeIfLastVersionTooLongAgo()
        if(this.hasNoVersion()) {
            CA.sendGoogleAnalyticsEvent(CA.Category.Funnel, CA.Label.FunnelNewUserEnteredSite)
            this.setVersion()
        }
    }

    private setShouldForcePortraitModeIfLastVersionTooLongAgo() {
        const storageVersion = this.getStorageVersion()

        if(storageVersion == undefined) {
            UIVersionController.shouldForcePortraitModeIfLastVersionTooLongAgo = true
            return
        }

        const versionDifference = this.thisVersion - storageVersion
        UIVersionController.shouldForcePortraitModeIfLastVersionTooLongAgo = versionDifference > FORCE_PORTRAIT_INACTIVITY_THRESHOLD_VERSION_DURATION
    }

    private setVersion() {
        this.updateStorageVersion(this.thisVersion)
    }

    // refresh() {
    //     location.reload(true)
    // }

    isSameVersion(): boolean {
        if(this.getStorageVersion() == null) return false
        return this.getStorageVersion() == this.thisVersion
    }

    private hasNoVersion(): boolean {
        const storageVersion = this.getStorageVersion()
        return storageVersion == 0 || storageVersion == null
    }

    showPatchnotes() {
        if(this.isSameVersion()) return
        if(UIEntryUrlParameterController.suppressPopupsOnLoad == true) return
        this.willShowPatchnoteThisSession = true
        this.setVersion()
        const pnData = new PatchNoteData()
        CA.sendGoogleAnalyticsEvent(CA.Category.Lobby, CA.Label.GeneralShowingPatchNotePopup)
        const popup = new ViewPopupPatchNotes(pnData.getLast5(), pnData.getAnnouncements(), UIVersionController.patchNoteRemoveAction)
    }
}
